import type { BrandingCategories, BrandingTypographyElement, TypographyBranding } from '~/types/branding'
import type { FontFamily } from '~/types/design-system'

export function useBrandingTypography() {
  const { brandings } = storeToRefs(useStoreBranding())

  const extractTypography = (
    typographyCategory: BrandingCategories,
    typographyName: string,
    fontFamily: FontFamily,
    hasHoverColor: boolean = false
  ): TypographyBranding => {
    if (!brandings.value) return {} as TypographyBranding

    const category = brandings.value[typographyCategory]
    const element = category![typographyName as keyof typeof category]

    if (!element) return {} as TypographyBranding

    const { id, weight, size, color, alignment, text, hover_color } = element as unknown as BrandingTypographyElement

    return {
      id,
      fontWeight: weight,
      fontSize: size,
      color,
      hoverColor: hasHoverColor ? hover_color : color,
      textAlign: getTextAlignment(alignment),
      fontFamily,
      text
    }
  }

  return { extractTypography }
}
